/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AppSagasCRW6ModuleQueryVariables = {};
export type AppSagasCRW6ModuleQueryResponse = {
    readonly mandant: {
        readonly modules: ReadonlyArray<{
            readonly enabled: boolean;
            readonly name: string;
        } | null> | null;
    } | null;
};
export type AppSagasCRW6ModuleQuery = {
    readonly response: AppSagasCRW6ModuleQueryResponse;
    readonly variables: AppSagasCRW6ModuleQueryVariables;
};



/*
query AppSagasCRW6ModuleQuery {
  mandant {
    modules {
      enabled
      name
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Mandant",
    "kind": "LinkedField",
    "name": "mandant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Module",
        "kind": "LinkedField",
        "name": "modules",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppSagasCRW6ModuleQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppSagasCRW6ModuleQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e561371b0bbdef80ca09ce823eeaea21",
    "id": null,
    "metadata": {},
    "name": "AppSagasCRW6ModuleQuery",
    "operationKind": "query",
    "text": "query AppSagasCRW6ModuleQuery {\n  mandant {\n    modules {\n      enabled\n      name\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '7e98b565dff59af44723d53500cae105';
export default node;
